
/* injects from baggage-loader */
require('./data-entry-replacement-popover-list.component.html');

//import angular from 'angular';

//angular.module('AaApp.Opp').component('popoverList', {
//    templateUrl: '/app/components/something.component.html'
//});
